import { render, staticRenderFns } from "./CustomDocTypeDocumentPreview.vue?vue&type=template&id=092f2992&scoped=true"
import script from "./CustomDocTypeDocumentPreview.vue?vue&type=script&lang=js"
export * from "./CustomDocTypeDocumentPreview.vue?vue&type=script&lang=js"
import style0 from "./CustomDocTypeDocumentPreview.vue?vue&type=style&index=0&id=092f2992&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092f2992",
  null
  
)

export default component.exports